import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.224.333A.667.667 0 0 0 3.557 1v4h-.666a2 2 0 0 0-2 2v3.333a2 2 0 0 0 2 2h.666v2c0 .368.299.667.667.667h8a.667.667 0 0 0 .667-.667v-2h.666a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-.666V1a.667.667 0 0 0-.667-.667zM11.557 5V1.667H4.891V5zM2.891 6.333A.667.667 0 0 0 2.224 7v3.333a.667.667 0 0 0 .667.667h.666V9c0-.368.299-.667.667-.667h8c.368 0 .667.299.667.667v2h.666a.666.666 0 0 0 .667-.667V7a.666.666 0 0 0-.667-.667zm2 5.334v2h6.666v-4H4.891v2",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })